var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":_vm.id}},[_c('div',{staticClass:"section-wrapper",class:[
      _vm.boxed && 'boxed'
    ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }